var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "h2",
        {
          staticClass:
            "text-brown-400 font-extraBold text-30 mb-[25px] lg:mb-50"
        },
        [_vm._v("Ik solliciteer als")]
      ),
      _vm._v(" "),
      !_vm.loadingFormFields
        ? _c("form-base", {
            ref: "form",
            staticClass:
              "job-application-form grid grid-cols-1 lg:grid-cols-2 lg:gap-y-[19px] lg:gap-x-[50px] h-full lg:h-auto",
            on: { submit: _vm.submit },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function(ref) {
                    var invalid = ref.invalid
                    var loading = ref.loading
                    var success = ref.success
                    return [
                      _vm._l(_vm.sortedFields, function(field, field_name) {
                        return [
                          field.type === "text" &&
                          field.maxlength &&
                          field.maxlength <= 255
                            ? [
                                _c("form-input", {
                                  staticClass: "col-span-1",
                                  attrs: {
                                    name: field_name,
                                    placeholder: field.label,
                                    required: field.required,
                                    rules: _vm.getRules(field)
                                  },
                                  model: {
                                    value: _vm.payload[field_name],
                                    callback: function($$v) {
                                      _vm.$set(_vm.payload, field_name, $$v)
                                    },
                                    expression: "payload[field_name]"
                                  }
                                })
                              ]
                            : field.type === "date"
                            ? [
                                _c("form-date", {
                                  staticClass: "col-span-1",
                                  attrs: {
                                    name: field_name,
                                    placeholder: field.label,
                                    required: field.required,
                                    rules: _vm.getRules(field)
                                  },
                                  model: {
                                    value: _vm.payload[field_name],
                                    callback: function($$v) {
                                      _vm.$set(_vm.payload, field_name, $$v)
                                    },
                                    expression: "payload[field_name]"
                                  }
                                })
                              ]
                            : field.type === "email"
                            ? [
                                _c("form-input", {
                                  staticClass: "col-span-1",
                                  attrs: {
                                    name: field_name,
                                    placeholder: field.label,
                                    required: field.required,
                                    type: "email",
                                    rules: _vm.getRules(field)
                                  },
                                  model: {
                                    value: _vm.payload[field_name],
                                    callback: function($$v) {
                                      _vm.$set(_vm.payload, field_name, $$v)
                                    },
                                    expression: "payload[field_name]"
                                  }
                                })
                              ]
                            : field.type === "text" && !field.maxlength
                            ? [
                                _c("form-textarea", {
                                  staticClass: "col-span-1 lg:col-span-2",
                                  attrs: {
                                    "label-class": "hidden",
                                    name: field_name,
                                    placeholder: field.label,
                                    required: field.required,
                                    rules: _vm.getRules(field)
                                  },
                                  model: {
                                    value: _vm.payload[field_name],
                                    callback: function($$v) {
                                      _vm.$set(_vm.payload, field_name, $$v)
                                    },
                                    expression: "payload[field_name]"
                                  }
                                })
                              ]
                            : field.type === "image"
                            ? [
                                _c("form-file", {
                                  staticClass:
                                    "col-span-1 lg:col-span-2 h-[250px]",
                                  attrs: {
                                    accept: "images",
                                    label: field.label,
                                    name: field_name,
                                    placeholder: field.label,
                                    required: field.required,
                                    rules: _vm.getRules(field)
                                  },
                                  model: {
                                    value: _vm.payload[field_name],
                                    callback: function($$v) {
                                      _vm.$set(_vm.payload, field_name, $$v)
                                    },
                                    expression: "payload[field_name]"
                                  }
                                })
                              ]
                            : field.type === "file"
                            ? [
                                _c("form-file", {
                                  staticClass:
                                    "col-span-1 lg:col-span-2 h-[250px]",
                                  attrs: {
                                    accept: "files",
                                    label: field.label,
                                    name: field_name,
                                    placeholder: field.label,
                                    required: field.required,
                                    rules: _vm.getRules(field)
                                  },
                                  model: {
                                    value: _vm.payload[field_name],
                                    callback: function($$v) {
                                      _vm.$set(_vm.payload, field_name, $$v)
                                    },
                                    expression: "payload[field_name]"
                                  }
                                })
                              ]
                            : field.type === "education"
                            ? [
                                _c("FromJobToolzEducation", {
                                  staticClass: "col-span-1 lg:col-span-2",
                                  attrs: {
                                    name: field_name,
                                    placeholder: field.label,
                                    required: field.required,
                                    rules: _vm.getRules(field)
                                  },
                                  model: {
                                    value: _vm.payload[field_name],
                                    callback: function($$v) {
                                      _vm.$set(_vm.payload, field_name, $$v)
                                    },
                                    expression: "payload[field_name]"
                                  }
                                })
                              ]
                            : field.type === "experience"
                            ? [
                                _c("FromJobToolzExperience", {
                                  staticClass: "col-span-1 lg:col-span-2",
                                  attrs: {
                                    name: field_name,
                                    placeholder: field.label,
                                    required: field.required,
                                    rules: _vm.getRules(field)
                                  },
                                  model: {
                                    value: _vm.payload[field_name],
                                    callback: function($$v) {
                                      _vm.$set(_vm.payload, field_name, $$v)
                                    },
                                    expression: "payload[field_name]"
                                  }
                                })
                              ]
                            : field.type === "yes_no"
                            ? [
                                _c("FromJobToolzYesNo", {
                                  attrs: {
                                    name: field_name,
                                    placeholder: field.label,
                                    required: field.required,
                                    rules: _vm.getRules(field)
                                  },
                                  model: {
                                    value: _vm.payload[field_name],
                                    callback: function($$v) {
                                      _vm.$set(_vm.payload, field_name, $$v)
                                    },
                                    expression: "payload[field_name]"
                                  }
                                })
                              ]
                            : field.type === "multiple_choice"
                            ? [
                                _c("FromJobToolzMultipleChoice", {
                                  class: {
                                    "col-span-2":
                                      field.label ===
                                      "Waar ben je juist naar op zoek?"
                                  },
                                  attrs: {
                                    multiple: field.multiple,
                                    options: field.options,
                                    name: field_name,
                                    placeholder: field.label,
                                    required: field.required,
                                    rules: _vm.getRules(field)
                                  },
                                  model: {
                                    value: _vm.payload[field_name],
                                    callback: function($$v) {
                                      _vm.$set(_vm.payload, field_name, $$v)
                                    },
                                    expression: "payload[field_name]"
                                  }
                                })
                              ]
                            : [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(field.type) +
                                    "\n                "
                                )
                              ]
                        ]
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "mt-24" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.termsAccepted,
                              expression: "termsAccepted"
                            }
                          ],
                          attrs: {
                            type: "checkbox",
                            id: _vm._uid,
                            required: "true"
                          },
                          domProps: {
                            checked: Array.isArray(_vm.termsAccepted)
                              ? _vm._i(_vm.termsAccepted, null) > -1
                              : _vm.termsAccepted
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.termsAccepted,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.termsAccepted = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.termsAccepted = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.termsAccepted = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "text-brown-400",
                            attrs: { for: _vm._uid }
                          },
                          [
                            _vm._v("Ik heb de "),
                            _c(
                              "a",
                              {
                                staticClass: "underline",
                                attrs: { href: "/privacybeleid" }
                              },
                              [_vm._v("gebruiksvoorwaarden")]
                            ),
                            _vm._v(" gelezen en ga akkoord.")
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("form-error", {
                        staticClass: "col-span-1 lg:col-span-2",
                        attrs: { "error-response": _vm.errorResponse }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex col-span-1 lg:col-span-2 items-center  gap-32"
                        },
                        [
                          _c(
                            "form-submit",
                            {
                              staticClass:
                                "w-full mt-32 lg:mt-0 md:w-auto whitespace-nowrap",
                              attrs: {
                                disabled: invalid || !_vm.termsAccepted,
                                loading: loading,
                                success: success
                              }
                            },
                            [_vm._v("verstuur jouw sollicitatie")]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "font-bold" }, [
                            _vm._v(_vm._s(_vm.success_message))
                          ])
                        ],
                        1
                      )
                    ]
                  }
                }
              ],
              null,
              false,
              2704731606
            )
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }